export class DictionaryDefinition {
  constructor(
    readonly word: string,
    readonly date: string,
    readonly wordType: string,
    readonly definition: string,
    readonly etymology: string,
    readonly audioWavUrl: string | null = null
  ) {}

  get isPopulated() {
    return true;
  }
}



// WEBPACK FOOTER //
// ./stores/dictionary/DictionaryDefinition.ts